import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
/*
 * @Author: 曹小丽
 * @Description:
 * @Date: 2022-08-30 11:20:11
 * @LastEditTime: 2022-09-28 21:54:04
 * @FilePath: /insurforce-backstage-platform-side/src/views/reportForm/exportManage/utils.js
 */

const exportRules = {
  time: [{
    required: true,
    message: '请选择导出时间',
    trigger: 'change'
  }],
  customerId: [{
    required: true,
    message: '请选择保单归属',
    trigger: 'change'
  }],
  insuranceId: [{
    required: true,
    message: '请选择导出产品',
    trigger: 'change'
  }]
};
const policyStateData = [{
  key: 0,
  name: '待投保'
}, {
  key: 1,
  name: '待生效'
}, {
  key: 2,
  name: '保障中'
}, {
  key: 3,
  name: '已过期'
}, {
  key: 4,
  name: '退保中'
}, {
  key: 5,
  name: '已退保'
}, {
  key: 6,
  name: '退保失败'
}];
const examineStateData = [{
  key: 0,
  name: '审核中'
}, {
  key: 1,
  name: '审核通过'
}, {
  key: 2,
  name: '审核未通过'
}];
const orderStateData = [{
  key: 1,
  name: '已支付'
}, {
  key: 2,
  name: '已退款'
}, {
  key: 3,
  name: '部分退款'
}, {
  key: 4,
  name: '待支付'
}, {
  key: 5,
  name: '取消支付'
}];
const orderTypeData = [{
  key: 1,
  name: 'APP投保'
}, {
  key: 2,
  name: '批量投保'
}, {
  key: 3,
  name: 'H5投保'
}, {
  key: 4,
  name: 'API投保'
}, {
  key: 5,
  name: '线下业务'
}];
const getExportParams = value => {
  let type = '';
  switch (value) {
    case 1:
      type = 'policy';
      break;
    case 2:
      type = 'order';
      break;
    case 3:
      type = 'claims';
      break;
    default:
      break;
  }
  return type;
};
const filterGetLabel = (data, filterData) => {
  let result = {};
  data.map(item => {
    if (filterData.includes(item.value)) {
      Object.assign(result, {
        [item.value]: item.label
      });
      // result.push({[item.value]: item.label});
    }
  });
  return result;
};
export { exportRules, policyStateData, examineStateData, orderStateData, orderTypeData, getExportParams, filterGetLabel };